import React from 'react';

const GetSignContactsIcon = (type: string): JSX.Element => {
  switch (type) {
    case '-sharp-outlined':
      return (
        <svg width='6.25rem' height='6.25rem' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M38.457 38.4578L60.5679 60.5686'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M60.5679 38.4578L38.457 60.5686'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M49.5 88C70.2107 88 87 71.2107 87 50.5C87 29.7893 70.2107 13 49.5 13C28.7893 13 12 29.7893 12 50.5C12 71.2107 28.7893 88 49.5 88Z'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
          />
          <path
            d='M49.5001 81.0705C66.3837 81.0705 80.0705 67.3837 80.0705 50.5001C80.0705 33.6165 66.3837 19.9297 49.5001 19.9297C32.6165 19.9297 18.9297 33.6165 18.9297 50.5001C18.9297 67.3837 32.6165 81.0705 49.5001 81.0705Z'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
        </svg>
      );

    default: //"-sharp-filled"
      return (
        <svg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M50.5 86C70.6584 86 87 69.6584 87 49.5C87 29.3416 70.6584 13 50.5 13C30.3416 13 14 29.3416 14 49.5C14 69.6584 30.3416 86 50.5 86Z'
            fill='var(--tint-brand-color)'
          />
          <path
            d='M50.5001 80.0705C67.3837 80.0705 81.0705 66.3837 81.0705 49.5001C81.0705 32.6165 67.3837 18.9297 50.5001 18.9297C33.6165 18.9297 19.9297 32.6165 19.9297 49.5001C19.9297 66.3837 33.6165 80.0705 50.5001 80.0705Z'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
          />
          <path
            d='M39.457 38.4578L61.5679 60.5686'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M61.5679 38.4578L39.457 60.5686'
            stroke='var(--secondary-brand-color)'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
  }
};

export default GetSignContactsIcon;
